import o from "./ScalarLoading.vue2.js";
import { useLoadingState as i } from "./ScalarLoading.vue2.js";
/* empty css                   */
import t from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ t(o, [["__scopeId", "data-v-f525638b"]]);
export {
  f as default,
  i as useLoadingState
};
